export const truncateToDecimals = (value, decimals = 2) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  const factor = 10 ** decimals
  return Math.trunc(n * factor) / factor
}

const euroToCents = (euro) =>
  Math.trunc(truncateToDecimals(euro, 2) * 100 + 1e-8)

export const formatTruncatedNumber = (value) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return '0.00'
  const sign = n < 0 ? '-' : ''
  const cents = Math.abs(euroToCents(n))
  const intPart = Math.floor(cents / 100)
  const frac = String(cents % 100).padStart(2, '0')
  return `${sign}${intPart}.${frac}`
}

export const formatMoney = (value) => `${formatTruncatedNumber(value)}€`

export const getItemIvaRate = (item) => {
  const rawIva = item?.IVACP ?? item?.IVA ?? 0
  const normalized = Number(rawIva)
  return Number.isFinite(normalized) ? normalized : 0
}

export const grossToNet = (amount, iva) => {
  const n = Number(amount)
  if (!Number.isFinite(n)) return 0
  const divisor = 1 + (Number(iva) || 0) / 100
  return divisor > 0 ? n / divisor : n
}

/** Unit price shown in the Price column (truncated gross or net). */
export const getLinePrice = (item, pricesIncludeIva = true) => {
  const grossPrice = truncateToDecimals(item?.marketPriceCP || 0, 2)
  if (pricesIncludeIva) return grossPrice
  return truncateToDecimals(grossToNet(grossPrice, getItemIvaRate(item)), 2)
}

/** Line total = truncated unit price (cents) × truncated quantity. */
export const getLineTotalFromUnitPrice = (unitPrice, quantity) => {
  const truncatedUnitPrice = truncateToDecimals(unitPrice, 2)
  const truncatedQuantity = truncateToDecimals(quantity ?? 0, 2)
  const totalCents = Math.trunc(
    euroToCents(truncatedUnitPrice) * truncatedQuantity + 1e-8,
  )
  return totalCents / 100
}

export const getLineTotal = (item, pricesIncludeIva = true) =>
  getLineTotalFromUnitPrice(getLinePrice(item, pricesIncludeIva), item?.quantity)
